<script lang="ts">
  export let date: string | Date;
  export let tbc: { date: boolean; time: boolean };
  export let className: string = "";

  function parseDate(dateStr: string | Date) {
    if (typeof dateStr === "string") {
      dateStr = dateStr.substring(0, 23);
    }
    const dateObject = new Date(dateStr);
    // Get day, month, and year
    const day = dateObject.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[dateObject.getMonth()];
    const year = dateObject.getFullYear();

    // Get hours and minutes
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const formattedMinutes = minutes <= 10 ? `0${minutes}` : minutes;

    return {
      day,
      month,
      year,
      hours,
      minutes: formattedMinutes,
    };
  }

  const { day, month, year, hours, minutes } = parseDate(date);
  const dtStr = new Date(date).toISOString().substring(0, 16).replace("T", " ");
</script>

<time class={`datetime ${className}`} datetime={dtStr}>
  {#if tbc?.date}
    <span class="sf-500">TBC</span>
  {:else}
    <div class="ddmmyy">
      <div class="day">{day}</div>
      <div class="mmyy">
        <div class="month pf-400">{month}</div>
        <div class="year pf-400">{year}</div>
      </div>
    </div>
    <hr />
    {#if tbc?.time}
      <div class="sf-300">TBC</div>
    {:else}
      <div class="time pf-400">{hours}:{minutes}</div>
    {/if}
  {/if}
</time>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .datetime {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    padding: 0.313em;
    border-radius: 0.313em;
    background: rgba(0, 0, 0, 0.06);
    gap: 0.125em;

    @include desktop {
      gap: 0.313em;
    }
    &.transparent {
      background: unset;
    }
    &.transparent-desk-only {
      @include desktop {
        background: unset;
      }
    }
  }

  .ddmmyy {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1px;
  }

  hr {
    height: 1px;
    width: 80%;
    background: #010ebc;
    opacity: 0.3;
    @include desktop {
      width: 50%;
    }
  }

  .day {
    display: flex;
    align-items: center;
    font-family: Nunito;
    /* font-size: 1.875em; // 30px; */
    // keep it in pixel
    font-size: 30px;
    line-height: 30px; /* 100% */
    font-weight: 400;
    @include desktop {
      font-weight: 700;
    }
  }

  .mmyy {
    font-size: 0.9em;
    line-height: 0.6em;
    @include desktop {
      .year {
        margin-top: 8px;
      }
    }
  }

  .month {
    margin-bottom: 0.125em;
  }

  .month,
  .year {
    font-size: 0.875em;
    text-transform: uppercase;
    @include desktop {
      font-size: 1em;
      line-height: 0.5625em;
    }
  }
  .time {
    font-size: 0.8125em;
    @include desktop {
      font-size: 1em;
      // line-height: 1.188em;
    }
  }
</style>
